import { createAsyncThunk } from "@reduxjs/toolkit";
import { useGetDataToken, useGetData } from "../../../hooks/useGetData";
import notify from "../../../Components/Utilities/notify";
import { useUpdateData } from "../../../hooks/useUpdateData";
import { useInsertData } from "../../../hooks/useInsertData";
import { useTranslationForThunk } from "../../../hooks/useTranslationForThunk"; 



export const reservationService = createAsyncThunk(
    "/reservationSlice/reservationService",
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await useInsertData('/api/v1/reservation/reservationService', data);
            console.log('res', response);        

            return response;
        } catch (error) {
            console.log("error", error);

            if (error.message === "Network Error") {
                 rejectWithValue("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ");
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");

            } else if (error?.response) {
                notify(error?.response?.data?.message ,"error")
                return rejectWithValue(error?.response?.data?.message || "An error occurred");
            } else {
                return rejectWithValue("حدث خطأ اثناء الاضافة من فضلك اكمل البيانات");
            }
        }
    }
);
export const getReservationService = createAsyncThunk(
    "/reservationSlice/getReservationService",
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await useGetData(`/api/v1/reservation/myReservationServices/${id}`);
            console.log('res', response);        

            return response;
        } catch (error) {
            console.log("error", error);

            if (error.message === "Network Error") {
                 rejectWithValue("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ");
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");

            } else if (error?.response) {
                // notify(error?.response?.data?.message ,"error")
                 notify("حدث خطأ حاول مرة اخري","error");
                return rejectWithValue(error?.response?.data?.message || "An error occurred");
            } else {
                notify("حدث خطأ حاول مرة اخري","error");
                return rejectWithValue("حدث خطأ حاول مرة اخري ");
            }
        }
    }
);
export const getCoupon = createAsyncThunk(
    "/reservationSlice/getCoupon",
    async ({ code }, { rejectWithValue }) => {
        // const t = useTranslationForThunk();
        try {
            const response = await useGetData(`/api/v1/settings/getCoupon/${code}`);
            // notify(t('couponAddedSuccess') ,"success")
            console.log('res', response);        

            return response;
        } catch (error) {
            console.log("error", error);

            if (error.message === "Network Error") {
                 rejectWithValue("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ");
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");

            } else if (error?.response) {
                notify(error?.response?.data?.message ,"error")
                return rejectWithValue(error?.response?.data?.message || "An error occurred");
            } else {
                return rejectWithValue("حدث خطأ اثناء الاضافة من فضلك اكمل البيانات");
            }
        }
    }
);

export const resetCopon = createAsyncThunk(
    "/reservationSlice/resetCopon",
     ( ) => {
       return null
    }
);
export const reservationPackage = createAsyncThunk(
    "/reservationSlice/reservationPackage",
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await useInsertData('/api/v1/reservation/reservationPackage', data);
            console.log('res', response);        

            return response;
        } catch (error) {
            console.log("error", error);

            if (error.message === "Network Error") {
                 rejectWithValue("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ");
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");

            } else if (error?.response) {
                notify(error?.response?.data?.message ,"error")
                return rejectWithValue(error?.response?.data?.message || "An error occurred");
            } else {
                return rejectWithValue("حدث خطأ اثناء الاضافة من فضلك اكمل البيانات");
            }
        }
    }
);
export const reservationServiceFromPackage = createAsyncThunk(
    "/reservationSlice/reservationServiceFromPackage",
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await useInsertData('/api/v1/reservation/reservationServiceFromPackage', data);
            console.log('res', response);        

            return response;
        } catch (error) {
            console.log("error", error);

            if (error.message === "Network Error") {
                 rejectWithValue("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ");
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");

            } else if (error?.response) {
                notify(error?.response?.data?.message ,"error")
                return rejectWithValue(error?.response?.data?.message || "An error occurred");
            } else {
                return rejectWithValue("حدث خطأ اثناء الاضافة من فضلك اكمل البيانات");
            }
        }
    }
);
export const getReservationPackage = createAsyncThunk(
    "/reservationSlice/getReservationPackage",
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await useGetData(`/api/v1/reservation/myReservationPackages/${id}`);
            console.log('res', response);        

            return response;
        } catch (error) {
            console.log("error", error);

            if (error.message === "Network Error") {
                 rejectWithValue("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ");
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");

            } else if (error?.response) {
                // notify(error?.response?.data?.message ,"error")
                return rejectWithValue(error?.response?.data?.message || "An error occurred");
            } else {
                return rejectWithValue("حدث خطأ اثناء الاضافة من فضلك اكمل البيانات");
            }
        }
    }
);
export const getServicesReservationFromPackage = createAsyncThunk(
    "/reservationSlice/getServicesReservationFromPackage",
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await useGetData(`/api/v1/reservation/myReservationServicesPackages/${id}`);
            console.log('res', response);        

            return response;
        } catch (error) {
            console.log("error", error);

            if (error.message === "Network Error") {
                 rejectWithValue("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ");
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");

            } else if (error?.response) {
                notify(error?.response?.data?.message ,"error")
                return rejectWithValue(error?.response?.data?.message || "An error occurred");
            } else {
                return rejectWithValue("حدث خطأ اثناء الاضافة من فضلك اكمل البيانات");
            }
        }
    }
);
export const checkExpiredService = createAsyncThunk(
    "/reservationSlice/checkExpiredService",
    async ({id, data} , { rejectWithValue }) => {
        try {
            const response = await useInsertData(`/api/v1/reservation/checkExpiredService/${id}`,data);
            console.log('res', response);        

            return response;
        } catch (error) {
            console.log("error", error);

            if (error.message === "Network Error") {
                 rejectWithValue("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ");
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");

            } else if (error?.response) {
                notify(error?.response?.data?.message ,"error")
                return rejectWithValue(error?.response?.data?.message || "An error occurred");
            } else {
                return rejectWithValue("حدث خطأ اثناء الاضافة من فضلك اكمل البيانات");
            }
        }
    }
);
export const cancelService = createAsyncThunk(
    "/reservationSlice/cancelService",
    async ({id='', data}) => {
        try {
            const response = await useUpdateData(`/api/v1/reservation/cancelService/${id}`, data);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else if (error.response.data)
             return notify(error.response.data,"error");
            else 
             return notify("لا يمكن الغاء الخدمه في الوقت الحالي","error");
        }
    }
);
export const editService = createAsyncThunk(
    "/reservationSlice/editService",
    async ({id='', data}) => {
        try {
            const response = await useUpdateData(`/api/v1/reservation/editService/${id}`, data);
            notify("تم تعديل الخدمه بنجاح","success");
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else if (error.response.data)
             return notify(error.response.data,"error");
            else 
             return notify("لا يمكن تعديل الخدمه في الوقت الحالي","error");
        }
    }
);


export const stopPackage = createAsyncThunk(
    "/reservationSlice/stopPackage",
    async ({ id,data }, { rejectWithValue }) => {
        try {
            const response = await useInsertData(`/api/v1/reservation/stopPackage/${id}`, data);
            console.log('res', response);        

            return response;
        } catch (error) {
            console.log("error", error);

            if (error.message === "Network Error") {
                 rejectWithValue("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ");
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");

            } else if (error?.response) {
                notify(error?.response?.data?.message ,"error")
                return rejectWithValue(error?.response?.data?.message || "An error occurred");
            } else {
                return rejectWithValue("حدث خطأ اثناء الاضافة من فضلك اكمل البيانات");
            }
        }
    }
);
export const resumePackage = createAsyncThunk(
    "/reservationSlice/stopPackage",
    async ({ id,data }, { rejectWithValue }) => {
        try {
            const response = await useInsertData(`/api/v1/reservation/resumptionPackage/${id}`, data);
            console.log('res', response);        

            return response;
        } catch (error) {
            console.log("error", error);

            if (error.message === "Network Error") {
                 rejectWithValue("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ");
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");

            } else if (error?.response) {
                notify(error?.response?.data?.message ,"error")
                return rejectWithValue(error?.response?.data?.message || "An error occurred");
            } else {
                return rejectWithValue("حدث خطأ اثناء الاضافة من فضلك اكمل البيانات");
            }
        }
    }
);

export const getStoppedPackage = createAsyncThunk(
    "/reservationSlice/getStoppedPackage",
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await useGetData(`/api/v1/reservation/getStopPackage/${id}`);
            console.log('res', response);        

            return response;
        } catch (error) {
            console.log("error", error);

            if (error.message === "Network Error") {
                 rejectWithValue("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ");
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");

            } else if (error?.response) {
                // notify(error?.response?.data?.message ,"error")
                 notify("حدث خطأ حاول مرة اخري","error");
                return rejectWithValue(error?.response?.data?.message || "An error occurred");
            } else {
                notify("حدث خطأ حاول مرة اخري","error");
                return rejectWithValue("حدث خطأ حاول مرة اخري ");
            }
        }
    }
);



export const checkScheduleTime = createAsyncThunk(
    "/reservationSlice/checkScheduleTime",
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await useInsertData(`/api/v1/reservation/checkScheduleTime`, data);
            console.log('res', response);        

            return response;
        } catch (error) {
            console.log("error", error);

            if (error.message === "Network Error") {
                 rejectWithValue("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ");
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");

            } else if (error?.response) {
                notify(error?.response?.data?.message ,"error")
                return rejectWithValue(error?.response?.data?.message || "An error occurred");
            } else {
                return rejectWithValue("حدث خطأ اثناء الاضافة من فضلك اكمل البيانات");
            }
        }
    }
);

export const getLoyalPoint = createAsyncThunk(
    "/reservationSlice/getLoyalPoint",
    async ({id},{ rejectWithValue }) => {
        try {
            const response = await useGetData(`/api/v1/reservation/units?clientId=${id}`);
            // notify(t('couponAddedSuccess') ,"success")
            console.log('res', response);        

            return response;
        } catch (error) {
            console.log("error", error);

            if (error.message === "Network Error") {
                 rejectWithValue("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ");
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");

            } else if (error?.response) {
                notify(error?.response?.data?.message ,"error")
                return rejectWithValue(error?.response?.data?.message || "An error occurred");
            } else {
                return rejectWithValue("حدث خطأ اثناء الاضافة من فضلك اكمل البيانات");
            }
        }
    }
);